export default __webpack_public_path__ + "static/media/depresion-min.27c5d17e.jpg";